import React from "react";
import axios from "axios";
import { API_URL } from '../../utils/auth';
import "./KnowledgeBase.css";

const KnowledgeBase = () => {
    const [articles, setArticles] = React.useState([]);
    const [loading, setLoading] = React.useState(true);

    React.useEffect(() => {
        const fetchArticles = async () => {
            try {
                const response = await axios.get(`${API_URL}/utils/get-articles`, {
                    params: {
                        collectionId: "67e56698b1d60a0331334869"
                    }
                });
                
                const formattedArticles = response.data.articles.items.map(item => ({
                    id: item.id,
                    title: item.name
                }));
                
                setArticles(formattedArticles);
            } catch (error) {
                console.error("Error fetching articles:", error);
            } finally {
                setLoading(false);
            }
        };

        fetchArticles();
    }, []);

    const openArticle = React.useCallback((e, id) => {
        e.preventDefault();
        e.stopPropagation();
        e.nativeEvent.stopImmediatePropagation();

        if (e.defaultPrevented) return;
        e.preventDefault();
        
        if (window.Beacon && !window.beaconTriggered) {
            window.beaconTriggered = true;
            window.Beacon("article", id);
            
            setTimeout(() => {
                window.beaconTriggered = false;
            }, 1000);
        }
    }, []);

    return (
        <div className="knowledge-base">
          {loading ? (
            <p className="knowledge-base__loading">Loading…</p>
          ) : (
            <div className="knowledge-base__container">
              <h1 className="knowledge-base__title">Knowledge Base</h1>
              <ul className="knowledge-base__list">
                {articles.map((article) => (
                  <li key={article.id} className="knowledge-base__item">
                    <a
                      href="#"
                      onClick={(e) => openArticle(e, article.id)}
                      data-beacon-article={article.id}
                      className="knowledge-base__link"
                    >
                      {article.title}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          )}
        </div>
    );
};

export default KnowledgeBase;